<div class="clone-notification-panel" *ngIf="show">
  <!-- Header -->
  <div class="notification-header">
    <h4 class="header-title">{{ 'SHARED.NOTIFICATIONS' | translate }} ({{ notifications.length }})</h4>
    <div class="header-actions">
      <button
        class="clear-btn"
        *ngIf="hasCompletedNotifications()"
        (click)="clearAll()"
        [attr.aria-label]="'SHARED.CLEAR_COMPLETED' | translate"
      >
        {{ 'SHARED.CLEAR_ALL' | translate }}
      </button>
      <button
        class="close-btn"
        (click)="onClose()"
        [attr.aria-label]="'SHARED.CLOSE_NOTIFICATION' | translate"
      >
        <i class="pi pi-times text-lg"></i>
      </button>
    </div>
  </div>

  <!-- Body - Shows list of notifications -->
  <div class="notification-body">
    <div *ngIf="notifications.length === 0" class="empty-state">
      <i class="pi pi-bell text-4xl text-gray-300"></i>
      <p class="text-gray-500 mt-2">{{ 'SHARED.NO_NOTIFICATIONS' | translate }}</p>
    </div>

    <div *ngFor="let notification of notifications" class="notification-item">
      <div class="folder-info">
        <div class="folder-title">
          <span class="title-text">
            <img
              [src]="getStatusIcon(notification.status)"
              [alt]="notification.status"
            />
            <span class="ml-1" *ngIf="notification.status === 'in-progress'">
              {{ 'SHARED.CLONING_EXPERIMENT' | translate }}
            </span>
            <span class="ml-1" *ngIf="notification.status === 'completed'">
              {{ 'SHARED.CLONE_COMPLETED' | translate }}
            </span>
            <span class="ml-1" *ngIf="notification.status === 'failed'">
              {{ 'SHARED.CLONE_FAILED' | translate }}
            </span>
          </span>
          <span class="folder-name">
            {{ notification.experimentName }}
          </span>
        </div>
        <div class="folder-actions">
          <button
            class="action-btn"
            (click)="removeNotification(notification.id)"
            [pTooltip]="'SHARED.DISMISS' | translate"
            tooltipPosition="top"
          >
            <i class="pi pi-trash text-base"></i>
          </button>
        </div>
      </div>

      <!-- Progress Section -->
      <div
        class="progress-section"
        *ngIf="notification.status === 'in-progress'"
      >
        <!-- Progress Bar -->
        <div class="progress-bar-container">
          <div
            class="progress-bar"
            [style.width.%]="notification.progress || 0"
          ></div>
        </div>
        <!-- Progress Text -->
        <div class="progress-info">
          <span class="progress-text">
            {{ 'SHARED.CLONING_IN_PROGRESS' | translate: { name: notification.experimentName } }}
          </span>
          <i class="pi pi-spin pi-spinner text-[--pho_primary] text-base"></i>
        </div>
      </div>

      <!-- Success/Failed Message -->
      <div class="status-message" *ngIf="notification.status !== 'in-progress'">
        <span
          class="status-text"
          [ngClass]="{
            'success-text': notification.status === 'completed',
            'error-text': notification.status === 'failed',
          }"
        >
          {{ notification.message }}
        </span>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <!-- <div class="notification-footer" *ngIf="notifications.length > 0">
    <a class="view-all-link" (click)="onViewAll()">View all notifications</a>
  </div> -->
</div>
